import { videos, type Video } from "@/mocks/videos";

export interface VideoFilter {
  region: string;
  year: string;
  sort: string;
}

export const getVideoById = (id: string): Video | undefined => videos.find((v) => v.id === id);

export const getVideosByCategory = (category: string): Video[] =>
  category === "all" ? videos : videos.filter((v) => v.category === category);

export const getFeatured = (): Video[] => videos.filter((v) => v.featured).slice(0, 4);

export const filterAndSort = (list: Video[], filter: VideoFilter): Video[] => {
  let result = [...list];
  if (filter.region && filter.region !== "全部") {
    result = result.filter((v) => v.region === filter.region);
  }
  if (filter.year && filter.year !== "全部") {
    result = result.filter((v) => String(v.year) === filter.year);
  }
  if (filter.sort === "rating") {
    result.sort((a, b) => b.rating - a.rating);
  } else if (filter.sort === "update") {
    result.sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime());
  } else {
    result.sort((a, b) => b.rating + b.year / 1000 - (a.rating + a.year / 1000));
  }
  return result;
};

export const searchVideos = (list: Video[], keyword: string): Video[] => {
  const kw = keyword.trim().toLowerCase();
  if (!kw) return [];
  return list.filter(
    (v) =>
      v.title.toLowerCase().includes(kw) ||
      v.tags.some((t) => t.toLowerCase().includes(kw)) ||
      v.categoryName.toLowerCase().includes(kw)
  );
};

export const paginate = <T,>(list: T[], page: number, pageSize: number): T[] =>
  list.slice((page - 1) * pageSize, page * pageSize);

export const PAGE_SIZE = 8;